// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-buttons[data-v-1aef7981]{display:flex;justify-content:center}[data-v-1aef7981] .el-select{width:177px}", ""]);
// Exports
module.exports = exports;
